import { instance } from "./base.api";

const endpoint = "/budget";

export const budget = {
  getById: (id: string) => {
    return instance.get(`${endpoint}/${id}`);
  },
  create: (budgetData: any) => {
    return instance.post(endpoint, budgetData);
  },
  update: (id: string, budgetData: any) => {
    return instance.put(`${endpoint}/${id}`, budgetData);
  },
  updateInvoices: (id: string, budgetData: any) => {
    return instance.put(`${endpoint}/${id}/invoices`, budgetData);
  },
  delete: (id: string) => {
    return instance.delete(`${endpoint}/${id}`);
  },
};
